module.exports = __webpack_public_path__ + "img/select_pointer.d8bf5782.svg";